import { render } from "./SidebarMenuItemBot1.vue?vue&type=template&id=64c6579c&scoped=true"
import script from "./SidebarMenuItemBot1.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItemBot1.vue?vue&type=script&lang=js"

import "./SidebarMenuItemBot1.vue?vue&type=style&index=0&id=64c6579c&scoped=true&lang=scss"

import exportComponent from "/home/tachyon/wardrobe-test2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c6579c"]])

export default __exports__